import { useFormContext } from "react-hook-form";
import { FormControlLabel, Radio } from "@mui/material";

import { FormField } from "components/form/FormField/FormField";

import style from "../AddVaccineForm.module.css";

const ANSWERS = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

/**
 * "Is the client a Healthcare worker?" — Phase 2 §5.3.1.
 *
 * Radio buttons rather than a checkbox, and with no default selection, because an
 * unticked box is indistinguishable from a deliberate No and the two have opposite
 * consequences: unanswered is an error, while No makes an Indication for Vaccination
 * mandatory. The value stays `null` until the clinician chooses.
 *
 * The question mark in the label is part of the requirement, which asks for it as a
 * standardised naming convention.
 */
export const HealthcareWorkerField = () => {
  const { watch, setValue } = useFormContext();
  const answer = watch("healthcareWorker");

  return (
    <FormField name="healthcareWorker">
      <label className={style.pregnancyFormLabel}>
        Is the client a Healthcare worker? *
      </label>
      <div className={style.radioGroup}>
        {ANSWERS.map((option) => (
          <FormControlLabel
            key={option.label}
            value={option.label}
            control={
              <Radio
                size="small"
                checked={answer === option.value}
                inputProps={{
                  "data-testid": `healthcare-worker-${option.label.toLowerCase()}`,
                }}
                onChange={() =>
                  setValue("healthcareWorker", option.value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  })
                }
                sx={{ "&.Mui-checked": { color: "var(--green-900)" } }}
              />
            }
            label={option.label}
          />
        ))}
      </div>
    </FormField>
  );
};
